import Button from '@/components/base/Button';
import { SITE_CONFIG } from '@/config';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20glass%20walled%20meeting%20room%20in%20a%20Japanese%20tech%20company%20office%20Japanese%20business%20professionals%20men%20and%20women%20in%20their%2030s%20sitting%20around%20a%20light%20wooden%20table%20having%20a%20collaborative%20meeting%20laptops%20and%20documents%20on%20the%20table%20a%20large%20transparent%20monitor%20display%20mounted%20on%20the%20glass%20wall%20showing%20a%20colorful%20gantt%20chart%20with%20task%20bars%20milestone%20icons%20and%20progress%20lines%20through%20the%20floor%20to%20ceiling%20glass%20walls%20behind%20them%20a%20large%20bright%20open%20plan%20office%20is%20visible%20with%20other%20employees%20working%20at%20desks%20slightly%20blurred%20in%20shallow%20depth%20of%20field%20creating%20bokeh%20effect%20natural%20daylight%20flooding%20the%20entire%20space%20warm%20wood%20accents%20indoor%20plants%20clean%20minimalist%20Japanese%20contemporary%20interior%20design%20airy%20transparent%20sophisticated%20atmosphere&width=1600&height=900&seq=hero-office-2026&orientation=landscape&nocache=true"
          alt="チームでプロジェクトを進める明るいオフィス"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20">
        <div className="max-w-[660px] bg-black/55 backdrop-blur-md rounded-2xl p-8 md:p-10">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white text-sm font-medium mb-6 backdrop-blur-sm">
            AIプロジェクト管理ツール
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            AIがWBSとガントチャートを自動生成。<br />
            日報から進捗が自動更新されるプロジェクト管理ツール。
          </h1>
          <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8">
            {SITE_CONFIG.description}
          </p>
          <p className="text-sm text-white/70 mb-8">
            日英タイ3言語対応。日本と海外拠点のプロジェクト管理を、ひとつの画面で。
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <Button to="/free-trial/" size="lg" className="text-base px-8 py-4" dataCtaName="free_trial" dataCtaLocation="hero">
              無料で今すぐお試し
            </Button>
            <Button to="/contact/" variant="outline" size="lg" className="border-white/40 text-white hover:bg-white/10 text-base px-8 py-4" dataCtaName="demo_contact" dataCtaLocation="hero">
              デモ・導入相談を予約する
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
